const PalauSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112117)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#338AF3"
      />
      <path
        d="M15.6522 28.6959C20.4546 28.6959 24.3478 24.8028 24.3478 20.0003C24.3478 15.1979 20.4546 11.3047 15.6522 11.3047C10.8497 11.3047 6.95654 15.1979 6.95654 20.0003C6.95654 24.8028 10.8497 28.6959 15.6522 28.6959Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112117">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PalauSvg;
